import { render, staticRenderFns } from "./task_progress.vue?vue&type=template&id=2a976090"
import script from "./task_progress.vue?vue&type=script&lang=js"
export * from "./task_progress.vue?vue&type=script&lang=js"
import style0 from "./task_progress.vue?vue&type=style&index=0&id=2a976090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports